import { NextSeo } from 'next-seo'

import { HeadCanonicals } from 'src/components/_nextjs/HeadCanonicals'
import { config } from 'src/config'
import { getMetafield } from 'src/functions/util/getMetafield'

import type { OpenGraphMedia } from 'next-seo/lib/types'
import type { Product } from 'src/data/graphql-generated'
import type { ShopCanonicals } from 'src/types/Canonical'

interface ProductDetailSEOProps {
  product: Product
  handles: ShopCanonicals
}

export const ProductDetailSEO = ({ product, handles }: ProductDetailSEOProps) => {
  const {
    seo: { title: metaTitle, description: metaDescription },
    productType,
    images: { nodes: productImages },
    metafields,
  } = product

  const noIndex = getMetafield(metafields, 'seo', 'noindex') || false
  const isCoffeeProduct = productType === 'coffee'
  const urlPrefix = isCoffeeProduct ? 'k' : 'p'

  const editedImages = productImages.map((image) => ({ ...image, url: `${image.url}?width=1200&height=1200` }))

  const seoImage = [...(editedImages as OpenGraphMedia[])]

  const possibleImages = seoImage.length > 0 ? seoImage : config.nextSeo.openGraph.images

  return (
    <>
      <NextSeo
        title={metaTitle || undefined}
        titleTemplate={config.nextSeo.titleTemplate}
        description={metaDescription || undefined}
        openGraph={{ images: possibleImages }}
        noindex={noIndex}
      />

      <HeadCanonicals
        de={`/de/${urlPrefix}/${handles.de}`}
        en={handles.en ? `/en/${urlPrefix}/${handles.en}` : undefined}
      />
    </>
  )
}
